import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadcrumbsComponent from "../../Components/BreadCrumbs";
import LeftSideNav from "../../Components/LeftSideNav";
import Loader from "../../Components/Loader";
import TopNavBar from "../../Components/TopNavbar";
import Fonts from "../../Config/Fonts";
import { AppConstants } from "../../Constants/AppConstants";
import { getProductPurityDetailsAPI } from "../../Store/Action/productPurityAction";
import Colors from "../../theme/Colors";
import PurityModuleTable from "./Component/PurityTable";
import CustomTopView from "../../Components/CustomTopView";
import { useNavigate } from "react-router-dom";

const ProductPurityModule = () => {
  const searchInputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [totalCount, setTotalCount] = useState(1);
  const { userData } = useSelector((state) => state.user);
  const limit = AppConstants.limit;
  const rowsPerPageOptions = [25, 50, 100];
  const rowsPerPageLabel = "Raw Per Pages";

  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState(""); // Added searchQuery state

  const handleChangePage = useCallback((event, newPage) => {
    setPageNumber(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(event.target.value);
    setPageNumber(0);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setPageNumber(0); // Reset to the first page when search changes
  }, []);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Home" },
      { key: "2", href: "/productPurity", text: "Product Purity" },
    ]);
  }, []);

  
  const onAddProductPurity = useCallback(
    () => navigate("/AddProductPurity"),
    [navigate]
  );

  useEffect(() => {
    const productPurityAPI = async () => {
      try {
        const params = {
          searchQuery: searchQuery || undefined,
          page: pageNumber || undefined,
          limit: limit || undefined,
        };

        dispatch(
          getProductPurityDetailsAPI(params, (result) => {
            setProducts(result?.data || []);
            setTotalCount(result?.totalCount);

            if (searchInputRef.current) {
              searchInputRef.current.focus();
            }
          })
        );
      } catch (error) {
        console.log("Failed to fetch users:", error);
      }
    };
    productPurityAPI();
  }, [dispatch, limit, pageNumber, searchQuery]);

  const recordAfterSorting = products?.slice(
    pageNumber * rowsPerPage,
    (pageNumber + 1) * rowsPerPage
  );

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "20% 80%",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
        backgroundColor: Colors.bgColor,
      }}
    >
      <LeftSideNav />

      <div
        style={{
          backgroundColor: Colors.bgColor,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <TopNavBar
          leftSideText={`Hello ${userData?.data?.user_first_name}`}
          isDashboard={true}
        />
        <CustomTopView
          breadcrumbs={breadcrumbs}
          addButtonText={"Add Customer"}
          exportButtonText={"Export Customer"}
          rowsPerPage={rowsPerPage}
          handleRowsPerPageChange={handleChangeRowsPerPage}
          rowPerPageLabel={rowsPerPageLabel}
          onAddButtonClick={onAddProductPurity}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
        />

        <PurityModuleTable
          purityDetailData={recordAfterSorting}
          page={pageNumber}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalItems={totalCount}
          rowsPerPageOptions={rowsPerPageOptions}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
          rowsPerPageLabel={rowsPerPageLabel}
        />
      </div>
    </div>
  );
};

export default ProductPurityModule;
